import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private _cardDetails: any = undefined;
  checkNavigation: boolean;

  constructor() {}

  setCardDetails(cardDetails: any): void {
    this._cardDetails = cardDetails;
  }

  getCardDetails = (): any => this._cardDetails;

  resetCardDetails(): void {
    this._cardDetails = undefined;
    this.checkNavigation = false
  }
}
